var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDouglasIconsEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF00FF;}\n\t.st1{fill:none;stroke:#FF00FF;stroke-width:0.025;stroke-miterlimit:10;}\n\t.st2{fill:#00FF00;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:square;}\n\t.st4{clip-path:url(#SVGID_2_);}\n\t.st5{clip-path:url(#SVGID_4_);}\n\t.st6{clip-path:url(#SVGID_6_);}\n\t.st7{clip-path:url(#SVGID_8_);}\n\t.st8{clip-path:url(#SVGID_10_);enable-background:new    ;}\n\t.st9{clip-path:url(#SVGID_12_);}\n\t.st10{clip-path:url(#SVGID_14_);}\n\t.st11{clip-path:url(#SVGID_16_);}\n\t.st12{clip-path:url(#SVGID_18_);}\n\t.st13{clip-path:url(#SVGID_20_);}\n\t.st14{clip-path:url(#SVGID_22_);}\n\t.st15{clip-path:url(#SVGID_24_);}\n\t.st16{clip-path:url(#SVGID_26_);}\n\t.st17{clip-path:url(#SVGID_28_);}\n\t.st18{clip-path:url(#SVGID_30_);}\n\t.st19{clip-path:url(#SVGID_32_);}\n\t.st20{clip-path:url(#SVGID_34_);enable-background:new    ;}\n\t.st21{clip-path:url(#SVGID_36_);}\n\t.st22{clip-path:url(#SVGID_38_);}\n\t.st23{clip-path:url(#SVGID_40_);}\n\t.st24{clip-path:url(#SVGID_42_);}\n\t.st25{clip-path:url(#SVGID_44_);}\n\t.st26{clip-path:url(#SVGID_46_);}\n\t.st27{clip-path:url(#SVGID_48_);}\n\t.st28{fill:none;}\n\t.st29{fill:#1A1A18;}\n\t.st30{fill:#FFFFFF;}\n\t.st31{fill:#1D1D1B;}\n\t.st32{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GRID_x21_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Punkte_Sammeln"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Kostenloser_Versand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_2_"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lieferung"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_4_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_3_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_10_"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Merkzettel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_8_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_9_"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Warenkorb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_11_"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Beautycard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_6_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_7_"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Magazin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_6_"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Special"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_5_"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Gratis_Probe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_4_"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Einladung"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_3_"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Geschenk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_9_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_12_"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Bezahlen"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Umtausch"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_1_"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rabatt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_13_"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Drucker"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Kalender"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Social_Media_1_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M-2063.71143,65.71635v4.75961h-2.83057c-1.03369,0-1.73096,0.21635-2.09131,0.64904 c-0.3606,0.43269-0.54102,1.08172-0.54102,1.94711v3.40746h5.28247l-0.70312,5.33653h-4.57935V95.5h-5.51685V81.81611h-4.59741 v-5.33653h4.59741v-3.93031c0-2.23558,0.625-3.96935,1.875-5.20132s2.91479-1.84795,4.99414-1.84795 C-2066.05518,65.5-2064.68506,65.57211-2063.71143,65.71635z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -2276.65698,
    y: -3043.44727,
    width: 2760,
    height: 4201.5791
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -2025.5,
    y: 65.50095,
    width: 30,
    height: 29.99811
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -2455.38135,
    y: -3048.62744,
    width: 2762.6189,
    height: 4208.5166
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M-2010.47632,72.96585c-4.14868,0-7.51184,3.36347-7.51184,7.51235 c0,4.14907,3.36316,7.51241,7.51184,7.51241s7.51196-3.36334,7.51196-7.51241 C-2002.96436,76.32932-2006.32764,72.96585-2010.47632,72.96585 M-2010.47632,85.35471 c-2.69299,0-4.87622-2.18327-4.87622-4.8765c0-2.69318,2.18323-4.87644,4.87622-4.87644 c2.69312,0,4.87622,2.18326,4.87622,4.87644C-2005.6001,83.17144-2007.7832,85.35471-2010.47632,85.35471"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_10_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: -2455.38135,
    y: -3048.62744,
    width: 2762.6189,
    height: 4208.5166
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M-2001.46204,71.46337c0,0.82975-0.67261,1.50248-1.50232,1.50248s-1.50244-0.67273-1.50244-1.50248 c0-0.8298,0.67273-1.50247,1.50244-1.50247S-2001.46204,70.63358-2001.46204,71.46337"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -2455.38135,
    y: -3048.62744,
    width: 2762.6189,
    height: 4208.5166
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    d: "M-2063.71143,2.71635v4.75961h-2.83057c-1.03369,0-1.73096,0.21635-2.09131,0.64904 c-0.3606,0.4327-0.54102,1.08172-0.54102,1.94711v3.40746h5.28247l-0.70312,5.33653h-4.57935V32.5h-5.51685V18.81611h-4.59741 v-5.33653h4.59741v-3.9303c0-2.23558,0.625-3.96935,1.875-5.20132S-2069.90137,2.5-2067.82202,2.5 C-2066.05518,2.5-2064.68506,2.57211-2063.71143,2.71635z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: -2276.65698,
    y: -3106.44727,
    width: 2760,
    height: 4201.5791
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: -2025.5,
    y: 2.50094,
    width: 30,
    height: 29.99811
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: -2455.38135,
    y: -3111.62744,
    width: 2762.6189,
    height: 4208.5166
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_41_",
    d: "M-2010.47632,9.96585c-4.14868,0-7.51184,3.36348-7.51184,7.51235 c0,4.14907,3.36316,7.51241,7.51184,7.51241s7.51196-3.36335,7.51196-7.51241 C-2002.96436,13.32933-2006.32764,9.96585-2010.47632,9.96585 M-2010.47632,22.3547c-2.69299,0-4.87622-2.18326-4.87622-4.8765 c0-2.69318,2.18323-4.87644,4.87622-4.87644c2.69312,0,4.87622,2.18326,4.87622,4.87644 C-2005.6001,20.17144-2007.7832,22.3547-2010.47632,22.3547"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_43_",
    x: -2455.38135,
    y: -3111.62744,
    width: 2762.6189,
    height: 4208.5166
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_45_",
    d: "M-2001.46204,8.46337c0,0.82975-0.67261,1.50248-1.50232,1.50248s-1.50244-0.67273-1.50244-1.50248 c0-0.8298,0.67273-1.50248,1.50244-1.50248S-2001.46204,7.63358-2001.46204,8.46337"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    x: -2455.38135,
    y: -3111.62744,
    width: 2762.6189,
    height: 4208.5166
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Lupe"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "X"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Digital_Invoice"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Geschenkkarte"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "M\\xFClleimer"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Blitz"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Briefumschlag"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Gru\\xDFkarte"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "track_your_order"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "lieferung_in_filiale"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Standort"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Kontakt"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4_x2F_7"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Anmelden_x2F_Abmelden"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "uhr"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Info"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "_x21_"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "_x3F_"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Social_Media"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Parkm\\xF6glichkeit"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Gratis_beigabe"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "mehr_Service"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Tablet"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Home"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Zoom"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Bearbeiten"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 40,
    className: "st31",
    width: 37,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M45.03516,8.62109l-6.85449-6.854L10.07617,29.87061l-2.0498,8.10645l8.86133-1.2085L45.03516,8.62109z  M15.88672,34.8866l-3.99878-3.99866l20.64648-20.64648l4.02612,4.02612L15.9502,34.87793L15.88672,34.8866z M42.20703,8.62109 l-4.93945,4.93945l-4.02612-4.02612l4.93921-4.93921L42.20703,8.62109z"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Benutzer_suchen"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Online_Konto_anlegen"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Kundeninfo"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Tages_Make-Up"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Abend_Make-Up"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Termin_speichern"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Beauty_Mirror"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Gl\\xFChbirne"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Sonder\\xF6ffnungszeiten"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Erinnerngsservice"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Color_Expert"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Open"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "\\xF6ffentliche_Verkehrsmittel"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Scanner"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Einstellungen"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Video"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Online_Produktreservierung"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "surprise_Sample"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouglasIconsEdit);
export default __webpack_public_path__ + "static/media/Douglas_Icons_Edit.1f1df17c.svg";
export { ForwardRef as ReactComponent };